<template>
  <v-dialog
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
    max-width="500">
    <v-card>
      <v-app-bar flat dark color="primary">
        <v-toolbar-title>Abrechnung(en) versenden</v-toolbar-title>
      </v-app-bar>
      <v-card>
        <v-card-text v-if="yearMonth" primary-title>
          <p>Möchten sie die Abrechnungen des Monats <b>{{mapYearMonth(yearMonth)}}</b> wirklich versenden?</p>
          <v-icon color="warning">warning</v-icon>Die Anzahl der versendeten E-Mails kann wenniger sein als ihre Auswahl, da nur veröffentlichte Abrechnung versendet werden können!
        </v-card-text>
        <v-card-text v-else-if="invoices && invoices.length > 1" primary-title>
          <p>Möchten sie die <b>{{invoices.length}}</b> Abrechnungen wirklich versenden?</p>
          <v-icon color="warning">warning</v-icon>Die Anzahl der versendeten E-Mails kann wenniger sein als ihre Auswahl, da nur veröffentlichte Abrechnung versendet werden können!
        </v-card-text>
        <v-card-text v-else-if="invoice && invoice.type === 'CUSTOMER_INVOICE'" primary-title>
          <p>Sie möchten die Abrechnung für den Kunden <b>{{invoice.customer.lastName}} {{invoice.customer.firstName}}</b>
          wirklich versenden?</p>
          <v-icon color="warning">warning</v-icon>Die Anzahl der versendeten E-Mails kann wenniger sein als ihre Auswahl, da nur veröffentlichte Abrechnung versendet werden können!
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="$emit('cancel')"
          >
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue"
            text
            @click="send"
          >
            Versenden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SendInvoiceConfirmDialogue',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    invoice: {
      type: Object,
      default: function () {
        return {
          id: 0,
          type: '',
          customer: {
            lastName: '',
            firstName: ''
          }
        }
      }
    },
    invoices: {
      type: Array,
      default: function () {
        return []
      }
    },
    yearMonth: {
      type: String,
      default: ''
    }
  },
  methods: {
    mapYearMonth: function (yearMonth) {
      const splitted = yearMonth.split('-')
      const date = new Date(splitted[0], splitted[1] - 1)
      return date.toLocaleString('de-de', {month: 'long'}) + ' ' + splitted[0]
    },
    send: function () {
      if (this.yearMonth) {
        this.$store.dispatch('bulkInvoiceSendByMonth', this.yearMonth)
          .finally(() => this.$emit('close'))
      } else if (this.invoices && this.invoices.length > 1) {
        this.$store.dispatch('bulkInvoiceSendByInvoices', this.invoices)
          .finally(() => this.$emit('close'))
      } else if (this.invoice.id !== 0) {
        this.$store.dispatch('sendInvoice', this.invoice.id)
          .finally(() => this.$emit('close'))
      }
    }
  }
}
</script>

<style scoped>
.v-subheader {
  margin-left: -32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Invoices/SendInvoiceConfirmDialogue.vue